// extracted by mini-css-extract-plugin
module.exports = {"userMenuLink":"styles_userMenuLink__3huEg","active":"styles_active__2Z1mL","userMenuLinkIcon":"styles_userMenuLinkIcon__3w5yJ","userMenuLinkText":"styles_userMenuLinkText__1wpvW"};